export default [
    {
        name: "organizationId",
        label: "Client",
        type: "relation",
        collection: "organizations",
        entityName: "organization",
        fields: ["name"],
    },
    {
        name: "signDate",
        label: "Sign Date",
        type: "date",
    },
    {
        name: "endDate",
        label: "End Date",
        type: "date",
    },
    {
        name: "collectionDate",
        label: "Collection Date",
        type: "date",
    },
    {
        name: "invoiceDate",
        label: "Invoice Date",
        type: "date",
    },
    {
        name: "createdAt",
        label: "Creation Date",
        type: "date",
    },
];
